// extracted by mini-css-extract-plugin
module.exports = {"container":"RewardModal_container__1xV5G","curt":"RewardModal_curt__3TFjw","colon":"RewardModal_colon__3S4ga"};